import { CagrValues, CagrResult } from './types';
import { ToolsTranslations } from '@/lib/translations/types';

export function calculateCagr(values: CagrValues, t?: ToolsTranslations['cagr']): CagrResult {
  const { startingAmount, endingAmount, years } = values;

  if (startingAmount <= 0) {
    return { cagr: null, isValid: false, message: t?.invalid.startingAmount ?? 'Startbelopp måste vara större än 0' };
  }
  if (endingAmount <= 0) {
    return { cagr: null, isValid: false, message: t?.invalid.endingAmount ?? 'Slutvärde måste vara större än 0' };
  }
  if (years <= 0) {
    return { cagr: null, isValid: false, message: t?.invalid.years ?? 'Antal år måste vara större än 0' };
  }

  const ratio = endingAmount / startingAmount;
  const cagr = Math.pow(ratio, 1 / years) - 1;
  if (!isFinite(cagr)) {
    return { cagr: null, isValid: false, message: t?.invalid.generic ?? 'Ogiltiga värden' };
  }
  return { cagr, isValid: true };
}


